import CardOrderTable from 'components/Cards/CardOrderTable'
import HeaderStats from 'components/Headers/HeaderStats'
import React from 'react'


export default function Orders() {
  return (
    <>
    <HeaderStats page={"Orders"} create={"/order/create"}/>
      <div className="flex flex-wrap mt-4 ">
        <div className="w-full px-4 mb-12 ">
          <CardOrderTable></CardOrderTable>
        </div>
      </div>
    </>
  )
}
